import React from 'react';
/* eslint-disable */
export function CloseCircle(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 0.5C3.84375 0.5 0.5 3.875 0.5 8C0.5 12.1562 3.84375 15.5 8 15.5C12.125 15.5 15.5 12.1562 15.5 8C15.5 3.875 12.125 0.5 8 0.5ZM10.5 9.5C10.8125 9.78125 10.8125 10.25 10.5 10.5312C10.2188 10.8438 9.75 10.8438 9.46875 10.5312L8 9.0625L6.5 10.5312C6.21875 10.8438 5.75 10.8438 5.46875 10.5312C5.15625 10.25 5.15625 9.78125 5.46875 9.5L6.9375 8L5.46875 6.53125C5.15625 6.25 5.15625 5.78125 5.46875 5.5C5.75 5.1875 6.21875 5.1875 6.5 5.5L8 6.96875L9.46875 5.5C9.75 5.1875 10.2188 5.1875 10.5 5.5C10.8125 5.78125 10.8125 6.25 10.5 6.53125L9.03125 8L10.5 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
